import { HomeOutlineIcon } from './HomeOutlineIcon';

/**
 * author: Google
 * id B4E2287E-8872-48AD-B765-83D82AF66CA3
 * name home-outline
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-outline.svg
 * tags
 * - Home Automation 
 * - Places 
 */
export const HouseOutlineIcon = HomeOutlineIcon;
export default HouseOutlineIcon